// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6bbd5dd2","879":"87236865"}[chunkId] + ".chunk.js";
};